function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(processAndSetInteropCodes);
import KJUR from 'jsrsasign';
import { eventChannel } from 'redux-saga';
import { call, put, select, take } from 'redux-saga/effects';
import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, initApplicationFailure, setAtcImmunizationCodes, setCiSisCodes, setConnectorConfigKo, setConnectorConfigOk, setDmpParameters, setInteropCodes, setModalError, setNosCodes, setPersistedConnectorConfiguration } from '../actions';
import { formatInteropCodesParams } from '../actions/config/commandParamsFormatters';
import commands from '../actions/config/commands';
import getCommandAction from '../actions/config/generateCommands';
import { apiSections } from '../constants';
import { createError, errorTypes, softwareErrors } from '../errors';
import { getDmpConnectJSHost, getDmpConnectJSPort, getDmpConnectJSProtocol, getEsRestHost } from '../helpers/accessors';
import { generateId } from '../utils/dataUtils';
import { setupSocket } from './connectorSagas';
var apiCodesToAppCodes = function apiCodesToAppCodes(array, validityField) {
  return array ? array.map(function (item) {
    return {
      code: item.s_code,
      label: item.s_displayName,
      oid: item.s_codeSystem || undefined,
      valid: !validityField || item[validityField] === undefined || item[validityField] === 1
    };
  }) : [];
};
var processInteropCodes = function processInteropCodes(codes) {
  var practiceSettings = codes.practiceSettings,
    healthcareSettings = codes.healthcareSettings,
    docTypes = codes.docTypes,
    docTypesTranslation = codes.docTypesTranslation,
    docCategories = codes.docCategories,
    docTypeToDocCategory = codes.docTypeToDocCategory,
    activitySectors = codes.activitySectors,
    professions = codes.professions,
    physicianSpecialities = codes.physicianSpecialities,
    adeliSpecialties = codes.adeliSpecialties,
    amoSpecialties = codes.amoSpecialties,
    dentistSpecialities = codes.dentistSpecialities,
    pharmacistSpecialities = codes.pharmacistSpecialities; // grouper les catégories
  var typeToCategory = docTypeToDocCategory.reduce(function (acc, curr) {
    (acc[curr.s_category] = acc[curr.s_category] || []).push(curr.s_type);
    return acc;
  }, {});
  return {
    adeliSpecialties: apiCodesToAppCodes(adeliSpecialties),
    amoSpecialties: apiCodesToAppCodes(amoSpecialties),
    activitySectors: apiCodesToAppCodes(activitySectors),
    practiceSettings: apiCodesToAppCodes(practiceSettings),
    healthcareSettings: apiCodesToAppCodes(healthcareSettings),
    professions: apiCodesToAppCodes(professions),
    physicianSpecialities: apiCodesToAppCodes(physicianSpecialities),
    dentistSpecialities: apiCodesToAppCodes(dentistSpecialities),
    pharmacistSpecialties: apiCodesToAppCodes(pharmacistSpecialities),
    categories: apiCodesToAppCodes(docTypes, 'i_validAlimentation'),
    docTypesTranslation: docTypesTranslation,
    metaCategories: docCategories.map(function (item) {
      return {
        code: item.s_code,
        label: item.s_displayName,
        types: apiCodesToAppCodes(docTypes.filter(function (type) {
          return typeToCategory[item.s_code].includes(type.s_code);
        }), 'i_validAlimentation')
      };
    })
  };
};
export function processAndSetInteropCodes(result) {
  var _result$data, practiceSettings, healthcareSettings, docTypes, docTypesTranslation, docCategories, docTypeToDocCategory, activitySectors, professions, physicianSpecialities, adeliSpecialties, amoSpecialties, dentistSpecialities, pharmacistSpecialities, processedCodes;
  return _regeneratorRuntime().wrap(function processAndSetInteropCodes$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _result$data = result.data, practiceSettings = _result$data.practiceSettings, healthcareSettings = _result$data.healthcareSettings, docTypes = _result$data.docTypes, docTypesTranslation = _result$data.docTypesTranslation, docCategories = _result$data.docCategories, docTypeToDocCategory = _result$data.docTypeToDocCategory, activitySectors = _result$data.activitySectors, professions = _result$data.professions, physicianSpecialities = _result$data.physicianSpecialities, adeliSpecialties = _result$data.adeliSpecialties, amoSpecialties = _result$data.amoSpecialties, dentistSpecialities = _result$data.dentistSpecialities, pharmacistSpecialities = _result$data.pharmacistSpecialities;
        processedCodes = processInteropCodes({
          practiceSettings: practiceSettings,
          healthcareSettings: healthcareSettings,
          docTypes: docTypes,
          docTypesTranslation: docTypesTranslation,
          docCategories: docCategories,
          docTypeToDocCategory: docTypeToDocCategory,
          activitySectors: activitySectors,
          professions: professions,
          physicianSpecialities: physicianSpecialities,
          adeliSpecialties: adeliSpecialties,
          amoSpecialties: amoSpecialties,
          dentistSpecialities: dentistSpecialities,
          pharmacistSpecialities: pharmacistSpecialities
        });
        _context.next = 4;
        return put(setInteropCodes(processedCodes));
      case 4:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
export var openDmpconnectJSWS = function openDmpconnectJSWS(hostname, port) {
  var webSocket = setupSocket(hostname, port);
  return new Promise(function (resolve, reject) {
    var timeout = setTimeout(function () {
      webSocket.close();
      reject(new Error('Timeout for Promise'));
      console.error('===============================');
      console.error('timeout when trying to connect to the WebSocket Server');
      console.error('===============================');
    }, 2000);
    webSocket.onopen = function () {
      webSocket.close();
      clearTimeout(timeout);
      resolve();
    };
  });
};
function testDMPConnectJS(hostname, port) {
  return eventChannel(function (emitter) {
    openDmpconnectJSWS(hostname, port).then(function () {
      return emitter({
        connected: true
      });
    }, function () {
      return emitter({
        connected: false
      });
    });
    var timer = setInterval(function () {
      openDmpconnectJSWS(hostname, port).then(function () {
        return emitter({
          connected: true
        });
      }, function () {
        return emitter({
          connected: false
        });
      });
    }, 3000);
    // The subscriber must return an unsubscribe function
    return function () {
      clearInterval(timer);
    };
  });
}
export var checkConnector = function checkConnector(_ref) {
  var _ref$retries = _ref.retries,
    retries = _ref$retries === void 0 ? 20 : _ref$retries;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dmpcjsProtocol, dmpcjsHost, dmpcjsPort, channel, i, stop, _yield$take, connected, error;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getDmpConnectJSProtocol);
        case 2:
          dmpcjsProtocol = _context2.sent;
          _context2.next = 5;
          return select(getDmpConnectJSHost);
        case 5:
          dmpcjsHost = _context2.sent;
          _context2.next = 8;
          return select(getDmpConnectJSPort);
        case 8:
          dmpcjsPort = _context2.sent;
          _context2.next = 11;
          return call(testDMPConnectJS, "".concat(dmpcjsProtocol, "://").concat(dmpcjsHost), dmpcjsPort);
        case 11:
          channel = _context2.sent;
          i = 0;
          stop = false;
        case 14:
          if (stop) {
            _context2.next = 40;
            break;
          }
          _context2.next = 17;
          return take(channel);
        case 17:
          _yield$take = _context2.sent;
          connected = _yield$take.connected;
          if (!(connected === true)) {
            _context2.next = 25;
            break;
          }
          _context2.next = 22;
          return put(setConnectorConfigOk());
        case 22:
          channel.close();
          _context2.next = 38;
          break;
        case 25:
          _context2.next = 27;
          return put(setConnectorConfigKo());
        case 27:
          if (!(retries >= 0 && i >= retries)) {
            _context2.next = 37;
            break;
          }
          _context2.next = 30;
          return put(initApplicationFailure());
        case 30:
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          _context2.next = 33;
          return put(setModalError({
            error: error
          }));
        case 33:
          channel.close();
          stop = true;
          _context2.next = 38;
          break;
        case 37:
          i += 1;
        case 38:
          _context2.next = 14;
          break;
        case 40:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  })();
};
export var handleGetInteropCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetInteropCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetInteropCodes$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return put(getCommandAction(commands.getInteropCodes, apiSections.INTEROPCODES, formatInteropCodesParams(['healthcareSettings', 'practiceSettings', 'docTypes', 'docTypesTranslation', 'docCategories', 'docTypesToDocCategories', 'activitySectors', 'professions', 'physicianSpecialities', 'adeliSpecialties', 'amoSpecialties', 'dentistSpecialities', 'pharmacistSpecialities']), {
          silentError: true
        }));
      case 2:
        _context3.next = 4;
        return take([dmpCommandSuccessContextualizedType(apiSections.INTEROPCODES), dmpCommandFailureContextualizedType(apiSections.INTEROPCODES)]);
      case 4:
        result = _context3.sent;
        if (!(result && result.type === dmpCommandFailureContextualizedType(apiSections.INTEROPCODES))) {
          _context3.next = 7;
          break;
        }
        return _context3.abrupt("return", false);
      case 7:
        _context3.next = 9;
        return call(processAndSetInteropCodes, result);
      case 9:
        return _context3.abrupt("return", true);
      case 10:
      case "end":
        return _context3.stop();
    }
  }, handleGetInteropCodes);
});
export var handleGetNosCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetNosCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetNosCodes$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return put(getCommandAction(commands.getNosCodes, apiSections.NOS_CODES, {
          TableNames: ['tre_r02-secteuractivite', 'tre_r209-typeactivite', 'tre_r37-typeprofessionfonction', 'tre_r342-xdstypesidentifiantsreferenceid']
        }));
      case 2:
        _context4.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.NOS_CODES));
      case 4:
        result = _context4.sent;
        _context4.next = 7;
        return put(setNosCodes(result.data));
      case 7:
      case "end":
        return _context4.stop();
    }
  }, handleGetNosCodes);
});
export var handleGetCiSisCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetCiSisCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetCiSisCodes$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return put(getCommandAction(commands.getCiSisCodes, apiSections.CISIS_CODES, {
          TableNames: ['JDV_LocalisationAnatomique_CISIS',
          // TODO : remplacer/ajouter par région anatomique
          'JDV_ModaliteAcquisition_CISIS']
        }));
      case 2:
        _context5.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.CISIS_CODES));
      case 4:
        result = _context5.sent;
        _context5.next = 7;
        return put(setCiSisCodes(result.data));
      case 7:
      case "end":
        return _context5.stop();
    }
  }, handleGetCiSisCodes);
});
export var handleGetAtcImmunizationCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetAtcImmunizationCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetAtcImmunizationCodes$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return put(getCommandAction(commands.getAtcCodes, apiSections.ATC_IMMUNIZATION_CODES, {
          Codes: ['J07%']
        }));
      case 2:
        _context6.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.ATC_IMMUNIZATION_CODES));
      case 4:
        result = _context6.sent;
        _context6.next = 7;
        return put(setAtcImmunizationCodes(result.data));
      case 7:
      case "end":
        return _context6.stop();
    }
  }, handleGetAtcImmunizationCodes);
});
export var handleDmpParameters = /*#__PURE__*/_regeneratorRuntime().mark(function handleDmpParameters() {
  var result;
  return _regeneratorRuntime().wrap(function handleDmpParameters$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.next = 2;
        return put(getCommandAction(commands.getDmpParameters, apiSections.DMP_PARAMETERS));
      case 2:
        _context7.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.DMP_PARAMETERS));
      case 4:
        result = _context7.sent;
        _context7.next = 7;
        return put(setDmpParameters(result.data));
      case 7:
      case "end":
        return _context7.stop();
    }
  }, handleDmpParameters);
});
export var generateAndSaveToken = /*#__PURE__*/_regeneratorRuntime().mark(function generateAndSaveToken(secret) {
  var connectorBaseURL, oHeader, oPayload, tNow, tEnd, sHeader, sPayload, sJWT;
  return _regeneratorRuntime().wrap(function generateAndSaveToken$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return select(getEsRestHost);
      case 2:
        connectorBaseURL = _context8.sent;
        // Header
        oHeader = {
          alg: 'HS256',
          typ: 'JWT'
        }; // Payload
        oPayload = {};
        tNow = KJUR.jws.IntDate.get('now');
        tEnd = KJUR.jws.IntDate.get('now + 1day');
        oPayload.iss = connectorBaseURL;
        oPayload.sub = 'mailto:contact@icanopee.net';
        oPayload.nbf = tNow;
        oPayload.iat = tNow;
        oPayload.exp = tEnd;
        oPayload.jti = generateId(20);
        oPayload.aud = connectorBaseURL;
        sHeader = JSON.stringify(oHeader);
        sPayload = JSON.stringify(oPayload);
        sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, secret);
        _context8.next = 19;
        return put(setPersistedConnectorConfiguration('connectorJWT', sJWT));
      case 19:
      case "end":
        return _context8.stop();
    }
  }, generateAndSaveToken);
});